import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  HostBinding,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { LocaleData, LocaleMap } from '../../../../helpers/locale-map';
import { NgSelectModule } from '@ng-select/ng-select';
import { StateService } from '../../../../services/state.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

let id = 0;

@Component({
  selector: 'app-locale-switcher',
  imports: [NgSelectModule, TranslocoDirective, ReactiveFormsModule, NgOptimizedImage],
  templateUrl: './locale-switcher.component.html',
  styleUrls: ['./locale-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocaleSwitcherComponent implements OnInit {
  private readonly stateService = inject(StateService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);

  readonly localeControl = new FormControl();
  readonly localeLabelFor = 'localeControl' + id++;
  readonly availableLocales = this.stateService.availableLocales
    .map(
      (locale) =>
        ({ locale, localeData: LocaleMap[locale] }) as {
          locale: string;
          localeData?: (typeof LocaleMap)['locale'];
        },
    )
    .filter(({ locale, localeData }) => {
      if (!localeData) {
        console.warn(`Missing data for ${locale} locale`);
      }

      return !!localeData;
    }) as { locale: string; localeData: LocaleData }[];

  @Input()
  noLabel = false;

  @HostBinding('class')
  @Input()
  appearance: 'footer' | 'menu' = 'footer';

  ngOnInit() {
    this.stateService.activeLocale$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((activeLocale) => {
        this.localeControl.setValue(activeLocale);
        this.cdr.markForCheck();
      });
  }
}
